import type { Holerite } from '../../models/holerite.model';

const CAMPOS_CONFIGURACAO = [
  'empresaNome', 'empresaNomeReduzido', 'empresaCnpj', 'empresaConvenio', 'empresaBanco',
  'empresaAgencia', 'empresaConta', 'competencia', 'dataPagamento', 'tipoPagamento',
  'dataGeracao', 'horaGeracao', 'dataDisponibilizacao', 'versaoArquivo', 'numeroLote',
  'numeroRemessa', 'codigoServico'
] as const;

/** Copia apenas valores explicitamente informados e comuns aos documentos. */
export function configuracaoRemessaDosHolerites(documentos: Holerite[]): Record<string, string> {
  const configuracao: Record<string, string> = {};
  if (!documentos.length) return configuracao;
  for (const chave of CAMPOS_CONFIGURACAO) {
    const valores = documentos.map(h => String(h.dados[chave] || '').trim());
    const valor = valores[0];
    if (!valor || !valores.every(v => v === valor)) continue;
    const codigo = valor.toLowerCase();
    configuracao[chave] = chave === 'tipoPagamento'
      ? codigo === 'mensal' ? 'E' : codigo === 'adiantamento' ? 'J' : valor
      : valor;
  }
  return configuracao;
}
